import React, {
    useState,
    useEffect,
    useImperativeHandle,
    forwardRef,
} from 'react'
import { hardcodeDropdown } from '../../../common/services'
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import { GridRowModes } from "@mui/x-data-grid";
import { isObjEmpty } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { failureToast } from "services/http";
import { saveOrDeleteMsg } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant";

import { generateRandomId } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import { editCellContainerStyle } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import { gridStyles, gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { ActionsCellComponent } from "views/pages/manage/masters/studentFinancials/paymentGatewaysConfiguration/common";
import { newRow } from "./utils";
import ALoader from "views/pages/manage/common/a-loader";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import { FaCheckSquare } from "react-icons/fa";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import MultiSelectCellComponentWithSearch from "views/pages/manage/common/commonComponents/SearchFilterView/MultiSelectCellComponentWithSearch";
import AInput from '../../../../../views/pages/manage/common/formFeilds/customInput/AInput';
import { regex } from "views/pages/manage/common/constant/regex/index";
import { deleteRecord } from '../services';
import { successToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { StatusCellComponent } from 'views/pages/manage/masters/studentFinancials/paymentGatewaysConfiguration/common';


const ApprovalSettingTable = ({
    rows,
    loading,
    setLoading,
    currentPage,
    totalRecords,
    pageChangeHandler,
    allActiveRoles = [],
    form,
    setForm
}, ref) => {

    const [rowModesModel, setRowModesModel] = useState({});
    const [rowData, setRowData] = useState(rows);
    const [rowForm, setRowForm] = useState({});

    const rowFormHandler = (value, key) =>
        setRowForm((prev) => ({
            ...prev,
            [key]: value
        }));

    useEffect(() => {
        setRowData(rows);
    }, [rows]);

    const startEditing = (id, form) => {
        setRowModesModel((oldModel) => ({
            [id]: { mode: GridRowModes.Edit },
        }));
        setRowForm(form);
    };

    const stopEditing = () => {
        const currForm = { ...rowForm };
        setRowModesModel((oldModel) => ({
            [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
        }));
        setRowForm({});
    };

    const handleEditClick = (params) => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            startEditing(params?.id, params?.row);
        }
    };

    const handleCancelClick = async (params) => {
        if (params?.row?.isNew) {
            setRowData(rows);
            setRowForm({});
        } else {
            stopEditing(params?.id);
        }
    };

    const handleSaveClick = () => {
        let tempRows = [...rows];

        if (rowForm?.isNew) {
            delete rowForm?.isNew;
            tempRows = [...tempRows, rowForm];
        } else {
            tempRows = [
                ...tempRows.filter(row => row?.id !== rowForm?.id),
                rowForm
            ];
        }

        setForm(prev => {
            return {
                ...prev,
                approvalSettingDTO: tempRows,
            };
        });

        setRowData(tempRows);
        stopEditing();
    };


    const handleDeleteClick = async (params) => {
        const deleteId = params?.row?.id;
        const resp = await deleteRecord(deleteId, setLoading);
        if (resp) {
            successToast("Request completed successfully!!!");
            setForm(prev => {
                let tempRows = [...prev.approvalSettingDTO];
                tempRows = tempRows.filter(row => row?.id !== deleteId);

                return {
                    ...prev,
                    approvalSettingDTO: tempRows
                }

            })
        }
    }

    const addNewRow = async () => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            let randomId = (generateRandomId() % 1000) + 'n';
            let emptyRow = {
                ...newRow(form?.approvalConfigNumber),
                isNew: true,
                id: randomId,
            };
            startEditing(randomId, emptyRow);
            setRowData((prev) => [emptyRow, ...prev]);
        }
    };

    const isTableInEditMode = Object.keys(rowForm)?.length !== 0;

    const getRefundTypeDropdown = (row) => {
        const filteredTypes = hardcodeDropdown?.subType?.filter(
            type => !rowData?.some(existing => existing?.subType === type)
        ) || [];

        if (!row.isNew) {
            const currentType = rowData?.find(el => el?.id === row?.id)?.subType;
            if (currentType) filteredTypes.push(currentType);
        }

        return filteredTypes;
    }

    useImperativeHandle(ref, () => ({
        addNewRow: addNewRow,
        startEditing: startEditing,
        stopEditing: stopEditing,
        isTableInEditMode: isTableInEditMode
    }));

    const columns = [

        new AGridColDef("subType", "Refund Type*", false)
            .setMinWidth(180)
            .setFlex(1)
            .editable(true)
            .setValueGetter((params) => params?.value?.label)
            .renderEditCellComponent((params) => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.subType}
                        handleChange={(value) => {
                            rowFormHandler(value, "subType");
                        }}
                        items={getRefundTypeDropdown(params?.row)}
                        isMulti={false}
                        placeholder={"Select"}
                        autoFocus={params?.hasFocus}
                    />
                </div>
            )),

        /*  new AGridColDef("isLoanComponent", "Loan Component", false)
              .setFlex(1)
              .editable(true)
              .setValueGetter((params) => params?.value?.label)
              .renderEditCellComponent((params) => (
                  <div style={editCellContainerStyle}>
                      <AAutoComplete
                          currentValue={rowForm?.isLoanComponent}
                          handleChange={(value) => {
                              rowFormHandler(value, "isLoanComponent");
                          }}
                          items={hardcodeDropdown?.isLoanComponent}
                          isMulti={false}
                          placeholder={"Select"}
                          autoFocus={params?.hasFocus}
                      />
                  </div>
              )),
  
          new AGridColDef("amount", "Amount (Upto)", false)
              .setFlex(1)
              .editable(true)
              .setValueGetter((params) => params?.value)
              .renderEditCellComponent((params) => (
                  <div style={editCellContainerStyle}>
                      <AInput
                          value={rowForm?.amount}
                          handler={(val) => {
                              if (val === "" || val === null) {
                                  rowFormHandler("", "amount");
                              } else {
                                  rowFormHandler(val, "amount");
                              }
                          }}
                          placeholder={""}
                          regex={regex?.numericDecimal}
                      />
                  </div>
              )),
          */
        new AGridColDef("LEVEL_1", "L1 Roles*", false)
            .setFlex(1)
            .editable(true)
            .renderCellComponent((params) =>
                <MultiSelectCellComponentWithSearch
                    data={params?.row?.roleApprovals?.LEVEL_1}
                    title={'L1 Roles'}
                />
            )
            .renderEditCellComponent((params) => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.roleApprovals?.LEVEL_1}
                        handleChange={(value) => {
                            setRowForm((prev) => ({
                                ...prev,
                                roleApprovals: {
                                    ...prev.roleApprovals,
                                    LEVEL_1: value
                                }
                            }));
                        }}
                        items={allActiveRoles}
                        isMulti={true}
                        placeholder={"Select"}
                        autoFocus={params?.hasFocus}
                        isShowCount
                    />
                </div>
            )),

        new AGridColDef("LEVEL_2", "L2 Roles", false)
            .setFlex(1)
            .editable(true)
            .renderCellComponent((params) =>
                <MultiSelectCellComponentWithSearch
                    data={params?.row?.roleApprovals?.LEVEL_2}
                    title={'L2 Roles'}
                />
            )
            .renderEditCellComponent((params) => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.roleApprovals?.LEVEL_2}
                        handleChange={(value) => {
                            setRowForm((prev) => ({
                                ...prev,
                                roleApprovals: {
                                    ...prev.roleApprovals,
                                    LEVEL_2: value,
                                    LEVEL_3: value?.length === 0 ? [] : prev.roleApprovals.LEVEL_3
                                }
                            }));
                        }}
                        items={allActiveRoles}
                        isMulti={true}
                        placeholder={"Select"}
                        autoFocus={params?.hasFocus}
                        isShowCount
                    />
                </div>
            )),

        new AGridColDef("LEVEL_3", "L3 Roles", false)
            .setFlex(1)
            .editable(true)
            .renderCellComponent((params) =>
                <MultiSelectCellComponentWithSearch
                    data={params?.row?.roleApprovals?.LEVEL_3}
                    title={'L3 Roles'}
                />
            )
            .renderEditCellComponent((params) => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.roleApprovals?.LEVEL_3}
                        handleChange={(value) => {
                            setRowForm((prev) => ({
                                ...prev,
                                roleApprovals: {
                                    ...prev.roleApprovals,
                                    LEVEL_3: value
                                }
                            }));
                        }}
                        items={allActiveRoles}
                        isMulti={true}
                        placeholder={"Select"}
                        autoFocus={params?.hasFocus}
                        isShowCount
                        isDisabled={rowForm?.roleApprovals?.LEVEL_2?.length == 0}
                    />
                </div>
            )),

        new AGridColDef("status", "Status", false)
            .setMinWidth(80)
            .setFlex(0.6)
            .columnAlign("center")
            .editable(true)
            .renderCellComponent((params) => (
                <StatusCellComponent value={params.value} />
            ))
            .renderEditCellComponent((params) => (
                <StatusCellComponent
                    value={rowForm?.status}
                    handleChange={(val) => rowFormHandler(val, "status")}
                />
            )),
        new AGridColDef("actions", "Action", false)
            .setMinWidth(160)
            .setFlex(2)
            .editable(true)
            // .pinColumnLast(true)
            .renderCellComponent(
                (params) =>

                    <ActionsCellComponent
                        mode={"view"}
                        handleEditClick={handleEditClick}
                        params={params}
                    // deleteIcon
                    // handleDeleteClick={handleDeleteClick}
                    />
            )
            .renderEditCellComponent((params) => (
                <ActionsCellComponent
                    mode={"edit"}
                    isSaveDisabled={(!rowForm?.subType || !rowForm?.roleApprovals?.LEVEL_1?.length)}
                    handleSaveClick={handleSaveClick}
                    // handleCancelClick={handleCancelClick}
                    params={params}
                    cancelIcon={
                        <AButton
                            variant="danger_filled"
                            size="xs"
                            onClick={() => handleCancelClick(params)}
                        >
                            Discard
                        </AButton>
                    }
                />
            )),
    ];


    return (
        <>
            {loading && <ALoader position="fixed" />}
            <ADataGrid
                removeWrapperContainer
                rowModesModel={rowModesModel}
                rows={rowData || []}
                columns={columns}
                rowId={(row) => row.id}
                rowHeight={50}
                loading={false}
                rowCount={rows?.length || 0}
                hidePagination
                nextButtonHandler={pageChangeHandler}
                currentPage={currentPage}
                components={{
                    ...gridComponents,
                    NoRowsOverlay: () => (
                        <NoRowOverlay message={loading ? "Loading..." : null} />
                    ),
                }}
                sx={gridStyles}
                autoHeight
            // pinLastColumn
            />
        </>
    );
}

export default forwardRef(ApprovalSettingTable);